'use strict';

/* ============================================================
   Soccer Revolution — Configuración de Firebase
   Conecta la Quiniela Mundial 2026 a un backend real (Firestore +
   Authentication) para que el login funcione desde cualquier
   dispositivo, sin enlaces ni códigos QR.
   ============================================================ */

const firebaseConfig = {
  apiKey: "AIzaSyCi2Won1C_ji7vVOQMTh5S5yUYslf3ZJGc",
  authDomain: "soccer-revolution-quiniela.firebaseapp.com",
  projectId: "soccer-revolution-quiniela",
  storageBucket: "soccer-revolution-quiniela.firebasestorage.app",
  messagingSenderId: "1038244545783",
  appId: "1:1038244545783:web:dcb7949336ee3f51787ff2",
  measurementId: "G-JZ5SXK5EEX"
};

firebase.initializeApp(firebaseConfig);
